import { bunja } from 'bunja';
import { atom } from 'jotai';

import { rewardImageAreaBunja } from '../_bid/bunja';
import { sparkAuctionBunja } from '../_bunja';

export const pastAuctionBunja = bunja(() => {
  const { sparkAuctionAtom, bidInfoAtom } = bunja.use(sparkAuctionBunja);
  const { imageUrlAtom } = bunja.use(rewardImageAreaBunja);
  const rewardAtom = atom((get) => {
    const { reward } = get(sparkAuctionAtom);
    return reward;
  });

  const winnerAtom = atom((get) => {
    const { highestBidder } = get(bidInfoAtom);
    if (!highestBidder) throw new Error('No highest bidder');
    return highestBidder;
  });

  const auctionResultAtom = atom((get) => {
    const { highestBidder, me } = get(bidInfoAtom);
    return {
      username: highestBidder?.nickname || null,
      num_sparks_bid: highestBidder?.amount || null,
      current_bid: me.amount,
      highest_bid: highestBidder?.amount || null,
    };
  });

  return {
    imageUrlAtom,
    rewardAtom,
    winnerAtom,
    auctionResultAtom,
  };
});
